import { render } from "./Webcam.vue?vue&type=template&id=1ada84ff&scoped=true"
import script from "./Webcam.vue?vue&type=script&lang=js"
export * from "./Webcam.vue?vue&type=script&lang=js"

import "./Webcam.vue?vue&type=style&index=0&id=1ada84ff&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ada84ff"]])

export default __exports__